
class ctaFixed{

	constructor() {

		const ctaFixed = document.querySelector('.fixed-cta');
		if( document.querySelector(".home-video") ){
			gsap.from(".home-video", {
				scrollTrigger: {
					start: 'bottom center',
					end: 99999,
					trigger: ctaFixed,
					toggleClass: 'enable'
				}
			});
		} else {
			gsap.from(".block-banner", {
				scrollTrigger: {
					start: 'bottom center',
					end: 99999,
					trigger: ctaFixed,
					toggleClass: 'enable'
				}
			});
		}

		if(ctaFixed){
			const ctaFixedToggle = document.querySelector('.toggle-cta');
			ctaFixedToggle.addEventListener( 'click', () => {
				ctaFixed.classList.toggle('open');
			});
		}

	}

}